
export default function ResultsSection() {
  const results = [
    {
      before: "Struggled with basic conversations",
      after: "Confidently speaks with native speakers",
      student: "Maria from Mexico",
      time: "4 weeks"
    },
    {
      before: "Knew grammar but couldn't speak",
      after: "Landed a job requiring English",
      student: "Ahmed from Egypt", 
      time: "6 weeks"
    },
    {
      before: "Afraid to speak English",
      after: "Travels confidently in English-speaking countries",
      student: "Yuki from Japan",
      time: "5 weeks"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real Students, Real Results
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how our method transforms students from struggling beginners to confident English speakers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {results.map((result, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-smile-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900">{result.student}</h3>
                <p className="text-sm text-blue-600 font-medium">Results in {result.time}</p>
              </div>
              
              <div className="space-y-4">
                <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-r-lg">
                  <p className="text-sm font-medium text-red-800">Before:</p>
                  <p className="text-sm text-red-700">{result.before}</p>
                </div>
                
                <div className="flex justify-center">
                  <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
                </div>
                
                <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-r-lg">
                  <p className="text-sm font-medium text-green-800">After:</p>
                  <p className="text-sm text-green-700">{result.after}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Get Similar Results?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Join thousands of students who have transformed their English skills with our proven method. 
              Your success story could be next!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-rocket-line mr-2"></i>
                Start Your Journey
              </button>
              <button className="border border-gray-300 text-gray-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-download-line mr-2"></i>
                Get Free Sample
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
